import { Form, Input, Select, Button, message } from "antd";
import useSupportService from "../../../../services/supportService";
import { useAuth } from "../../../../context/authContext";
import { useLanguage } from "../../../../context/LanguageContext";
import dashboardContent from "../../../../utils/dashboardContent";

const { TextArea } = Input;
const { Option } = Select;

const SupportTicketForm = () => {
  const [form] = Form.useForm();
  const { user } = useAuth();
  const { language } = useLanguage();
  const { createSupportTicket } = useSupportService();
  const text = dashboardContent[language].supportTicketForm;

  const onFinish = async (values) => {
    await createSupportTicket({
      sender: user._id,
      topic: values.topic,
      subject: values.subject,
      description: values.description,
    });
    form.resetFields();
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl min-w-full mx-auto p-6 bg-white rounded-lg shadow-lg">
        <h2 className="text-2xl font-semibold mb-6 text-gray-800">
          {text.title}
        </h2>
        <Form
          form={form}
          name="supportTicket"
          onFinish={onFinish}
          layout="vertical"
          className="space-y-4"
        >
          <Form.Item
            name="subject"
            label={text.subjectLabel}
            rules={[{ required: true, message: text.subjectRequired }]}
          >
            <Input className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
          </Form.Item>

          <Form.Item
            name="description"
            label={text.descriptionLabel}
            rules={[{ required: true, message: text.descriptionRequired }]}
          >
            <TextArea
              rows={4}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </Form.Item>

          <Form.Item
            name="topic"
            label={text.topicLabel}
            rules={[{ required: true, message: text.topicRequired }]}
          >
            <Select className="w-full">
              <Option value="System">{text.topicSystem}</Option>
              <Option value="Rechnung">{text.topicInvoice}</Option>
              <Option value="Account">{text.topicAccount}</Option>
              <Option value="Feature">{text.topicFeature}</Option>
              <Option value="Sonstiges">{text.topicOther}</Option>
            </Select>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="w-full bg-blue-500 hover:bg-blue-600 focus:ring-2 focus:ring-blue-300 text-white font-semibold py-2 px-4 rounded-md transition duration-300 ease-in-out"
            >
              {text.submitButton}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default SupportTicketForm;
